import React, { Component } from 'react';
import Select from '@material-ui/core/Select';
import { MenuItem, Grid, OutlinedInput, Button, Grow, Fade } from '@material-ui/core';
import ColumnField from './ColumnField';
import { observer } from 'mobx-react';

class ColumnFields extends Component {
  handleChange = (val, key) => {
    let data = this.props.value;

    if (key !== undefined) {
      this.replaceAliasPathInTemplate(key);
      data[key] = val;
    } else {
      data.push(val);
    }

    this.props.onChange(data)
  };

  replaceAliasPathInTemplate (key) {
    let data = this.props.value,
      props = this.props,
      type;

    if (!data[key]['value'] || !data[key]['column']) {
      return;
    }

    type = data[key]['value']['value'];

    if (type == "extract-body" || type == "extract-subject") {

      let templateHtml = type == "extract-body" ? props.template.html : props.subjectTemplate.html,
        templateText = type == "extract-body" ? props.template.text : props.subjectTemplate.text,
        templateKey = " {{" + data[key]['column']['alias_path'] + "}} ";

      templateHtml = templateHtml.replace("<span style=\"background: yellow;\">" + templateKey + "</span>", props.templateSelections[templateKey])
      templateText = templateText.replace(templateKey.slice(1, -1), props.templateSelections[templateKey])

      this.handleTemplateChange({
        text: templateText,
        html: templateHtml
      }, type == "extract-body" ? "template" : "subject_template");
    }
  }

  handleTemplateChange = (value, key) => {
    this.props.onChange(value, key)
  };


  handleTemplateSelectionChange = (key, value) => {
    this.props.onTemplateSelectionChange(value, key)
  }

  handleAddButtonClick = () => {
    this.handleChange([])
  }

  deleteColumnField = (key) => {
    let data = this.props.value;

    this.replaceAliasPathInTemplate(key);
    data.splice(key, 1);

    if (data.length == 0) {
      data = [[]];
    }

    this.props.onChange(data)
  }

  render () {
    let props = this.props,
      { value } = this.props;

    return (
      <Grid item container
        direction="column"
        justify="center"
        alignItems="center"
        spacing={3}
      >
        {
          value.map((val, key) => {
            return (
              <ColumnField
                key={key}
                columns={props.columns}
                value={val}
                template={props.template}
                subjectTemplate={props.subjectTemplate}
                templateSelections={props.templateSelections}
                onTemplateSelectionChange={this.handleTemplateSelectionChange}
                onTemplateChange={this.handleTemplateChange}
                isMultipleRows={props.isMultipleRows}
                multipleRowsData={props.multipleRowsData}
                handleMultipleRowsDataChange= {props.handleMultipleRowsDataChange}
                onChange={(val) => this.handleChange(val, key)}
                onDelete={() => { this.deleteColumnField(key); }} />
            );
          })
        }

        <Grid item container alignItems="flex-start">
          <Grow in={true}>

            <Button
              variant="contained"
              color="primary"
              onClick={this.handleAddButtonClick}
            >
              Add
          </Button>
          </Grow>
        </Grid>
      </Grid>
    );
  }
}

export default observer(ColumnFields);
